/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
// You need a specific loader for CSS files
Vue.component('multiselect', Multiselect)
export default {
  name: 'create-webinar-details',
  components: {
    datetime: Datetime,
    Multiselect,
  },
  props: [],
  data () {
    return {
      userProfileDetails:{},
      start_time:'',
      end_time:'',
      topic:'',
      users:'',
      userList:{},
      userListResults:[],
      options:[],
      submitted:false,
      sentUserData:[],
      file:null,
      uploadAttachmentName:'',
      max_webinar_attendance:'',
      selfUserId:'',
      is_superuser:false,
      is_public:false,
      minDatetime:new Date().toISOString()
    }
  },
  computed: {
    ...mapGetters([
      'isConditionalListOfAllUsersGetters',
      'selfUserInfoGetters'
    ]),
    getUserDetailsInfo(){
      this.userProfileDetails = this.$store.getters.selfUserInfoGetters.data;
      return;
    },
    checkTheSelfUserStatus(){
        if(this.userProfileDetails){
          if(this.userProfileDetails.is_superuser === true){
            this.is_superuser = true;
          }else{
            this.is_superuser = false;
          }
        }
    },
    getUserList() {
      this.userList = this.$store.getters.isConditionalListOfAllUsersGetters.data;
      return this.userList;
    },
    setIntialsState(){
      if(this.userList != undefined){
        this.userListResults = this.userList
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    }
  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID');
    }
    this.getUserDetailsInfo;
    this.getUserList;
    this.setIntialsState;
    this.checkTheSelfUserStatus;
  },
  methods: {
    updateEndTime() {
      if(this.start_time){
        const originalDate = this.start_time;
        const date = new Date(originalDate);
        date.setHours(date.getHours() + 1);
        const newDate = date.toISOString();
        this.end_time = newDate;
      }
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        // this.filesSize = this.$refs.file.files[0].size;
        this.uploadAttachmentName = this.files.name
      }  else {
        this.uploadAttachmentName = '';
      }
    },
    getWebinarListAgain(){
      this.$store.dispatch('getWebinarAllListFun').then((res)=>{
      })
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.users.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    createWebinarBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          if(this.is_superuser){
            this.sentUserData.push(this.users.id)
          }else{
            this.sentUserData.push(this.selfUserId)
          }
          let data = {
            topic:this.topic,
            start_time:this.start_time,
            end_time:this.end_time,
            users:this.sentUserData,
            is_public:this.is_public,
            is_active:false,
            is_webinar:true,
            max_webinar_attendance:this.max_webinar_attendance
          }
          this.$store.dispatch('createWebinarListFun', data)
            .then((res) => {  
              if(this.file != null){
                var formData = new FormData();
                formData.append('attachment', this.file);
                formData.append('filename', this.uploadAttachmentName);
                this.$store.dispatch('updateWebinarDetailsByIdFun', {data:{data:formData,id:res.data.data.id}}).then((res) => {
                  toast.success(res.data.msg);
                  this.getWebinarListAgain()
                  bus.$emit('createWebinarPopupBus', false);
                  $('body').removeClass('body_right_scroll_remove')
                  this.submitted =  false
                }).catch((err)=>{
                  this.submitted =  false
                  toast.error(err.data.msg);
                })
              }else{
                toast.success(res.data.msg);
                this.getWebinarListAgain()
                bus.$emit('createWebinarPopupBus', false);
                $('body').removeClass('body_right_scroll_remove')
                this.submitted =  false
              }
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeCreateMeetingPopup(){
      bus.$emit('createWebinarPopupBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  },
  watch: {
    getUserDetailsInfo(){
      return this.$store.getters.selfUserInfoGetters;
    },
    getUserList() {
      return this.$store.getters.isConditionalListOfAllUsersGetters;
    },
    userList(old_val, new_val){
      if(new_val == undefined){
          this.userListResults = old_val
          for(var i = 0; i < this.userListResults.length; i++){
            this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
          }
      }
    },
  },
}


